<template>
  <div class="sub-salary">
    <div class="sub-salary__header">
      <div class="sub-salary__header__left">
        <h1>Vikarløn</h1>
      </div>
      <div class="sub-salary__header__left">
        <a class="do-bttn do-bttn--with-icon" href="https://docendohelp.crisp.help/da/article/vikarlon-1b1x6yz/"
           target="_blank">
          <span class="icon-question3"></span>
          Guide
        </a>
        <button
          class="do-bttn do-bttn--with-icon"
          @click="setIsShowSalarySettings(true)">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
               class="mr-2 h-4 w-4">
            <path
              d="M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z"
              fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path>
          </svg>
          Opsætning
        </button>
        <SchoolsSelector
          v-if="isSchoolSelectorOn"
          :permission="permission"
          :schools="userSchools"
          :selectedSchoolIds="selectedSchoolIds"
          @toggleSchool="toggleSchool">
        </SchoolsSelector>
        <DoDatePickerRange
          :allowSameDate="true"
          :startDate="startDate"
          :endDate="endDate"
          :dateShortCutsProps="dateShortCuts"
          :maximumDateRange="89"
          @startChanged="startDateChanged"
          @endChanged="endDateChanged"
        ></DoDatePickerRange>
      </div>
    </div>
    <div class="sub-salary__sub-header">
      <SalaryFilters
        :activeFilter="activeFilter"
        :userDaysSorted="userDaysSorted"
        :isSalaryIntegrationActive="isSalaryIntegrationActive"
        @change="setFilter($event)">
      </SalaryFilters>
    </div>
    <div class="sub-salary__body">
      <Loader v-if="isLoading"></Loader>
      <h2 class="text-explainer marg-1-top" v-if="!isLoading && usersAndEventsFiltered.length < 1">
        <template v-if="selectedSchoolIds.length > 0">Ingen vikartimer i perioden</template>
        <template v-else>Ingen skoler valgt</template>
      </h2>
      <template v-else>
        <ul class="user-list">
          <li v-for="user in usersPackedInDaysWithProps" class="user-list__user">
            <div class="user-list__user__header">
              <h4>{{ user.v_user_name }}
              </h4>
              <div class="user-list__user__header__right">
                <ul>
                  <li v-for="sum in user.v_user_sums"
                      :key="sum.employment_id"
                      :class="{'user-list__user__footer__sums__sum--not-set': sum.employment_not_set}">
                    {{ sum.employment_title }}: <b>{{ sum.minutes_humanized }}</b>
                  </li>
                </ul>
                <button class="do-bttn do-bttn--small no-print"
                        @click="setActiveUserId(user.user_id)"
                        content="Se alle dage på personen"
                        v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }">
                  <span class="icon-enlarge2"></span>
                </button>
              </div>
            </div>
            <table v-for="userDay in user.days" :key="userDay.day" class="user-list__user__table"
                   :class="{'user-list__user__table--active': userDay.v_is_open}">
              <thead @click="setTheActiveUserDay(userDay)">
              <tr>
                <th>{{ userDay.v_date_formatted }}
                  <span class="do-pill do-pill--yellow" v-if="userDay.error && Object.keys(userDay.error).length">
                    Overførselsfejl
                  </span>
                </th>
                <th v-if="userDay.v_is_open">Kalender</th>
                <th v-if="userDay.v_is_open">Type</th>
                <th v-if="userDay.v_is_open">Vikar for</th>
                <th v-if="userDay.v_is_open">Ansættelse</th>
                <th v-if="isSalaryIntegrationActive && userDay.v_is_open">Lønkode</th>
                <th v-if="isSalaryIntegrationActive && userDay.v_is_open">Løbenummer</th>
                <th class="user-list__user__table__arrow">
                  <svg class="tw-icon tw-icon--red" v-if="userDay.v_unfilled" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                  <span class="icon-arrow-up4" v-if="!userDay.v_is_open"></span>
                  <span class="icon-arrow-down4" v-else></span>
                </th>
              </tr>
              </thead>
              <template v-if="userDay.v_is_open">
                <SalarySubsPerfUserDay
                  :user="user"
                  :userDay="userDay"
                  :isSalaryIntegrationActive="isSalaryIntegrationActive"
                  @updatePropOnLesson="updatePropOnLesson">
                </SalarySubsPerfUserDay>
                <tfoot>
                <tr>
                  <td :colspan="isSalaryIntegrationActive ? 8 : 6">
                    <div class="user-list__user__footer">
                      <span v-if="userDay.error" v-for="(error, index) in parseUserErrors(userDay.error)" :key="index"
                            class="do-pill do-pill--yellow do-pill--with-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                             stroke-linecap="round" stroke-linejoin="round" class="tw-icon tw-icon--yellow"><path
                          d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path> <line
                          data-v-050a44fb="" x1="12" y1="9" x2="12" y2="13"></line> <line x1="12" y1="17" x2="12.01"
                                                                                          y2="17"></line></svg>
                        {{ error }}
                      </span>
                      <ul class="user-list__user__footer__sums">
                        <li v-for="sum in userDay.v_sums"
                            :key="sum.employment_id"
                            :class="{'user-list__user__footer__sums__sum--not-set': sum.employment_not_set}">
                          {{ sum.employment_title }}: <b>{{ sum.minutes_humanized }}</b>
                          <button class="bttn bttn--white bttn--small do-copy-bttn"
                                  @click.stop.prevent="copyToClipboard(sum.minutes_to_copy, $event)"
                                  :content="'Kopieret ' + sum.minutes_to_copy"
                                  v-tippy="{
                                    onShow: hideTippy,
                                    trigger: 'manual',
                                    arrow: true,
                                    placement : 'top',
                                    zIndex: 2147483010
                                  }">
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 48 48" width="48">
                              <path d="M0 0h48v48h-48z" fill="none"/>
                              <path
                                d="M32 2h-24c-2.21 0-4 1.79-4 4v28h4v-28h24v-4zm6 8h-22c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm0 32h-22v-28h22v28z"/>
                            </svg>
                          </button>
                        </li>
                      </ul>
                      <div class="submit-buttons" v-if="userDay.state === 'approved'">
                        <button class="do-bttn do-bttn--danger"
                                @click="unApproveDay(userDay)"
                                :content="'Dagen vil blive genberegnet'"
                                v-tippy="{
                            arrow: true,
                            animateFill: false,
                            animation : 'shift-away',
                            zIndex: '999999992',
                            boundary: 'window'
                          }">
                          Fortryd godkendelse
                        </button>
                        <button class="do-bttn do-bttn--submit"
                                @click="changeStateIsSent(userDay)">
                          {{ isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet' }}
                        </button>
                      </div>
                      <template v-if="userDay.state === 'draft'">
                        <button class="do-bttn do-bttn--submit do-bttn--submit--disabled"
                                v-if="getIsDayValidated(userDay)"
                                :content="'Du skal vælge ansættelse på hver lektion'"
                                v-tippy="{
                            arrow: true,
                            animateFill: false,
                            animation : 'shift-away',
                            zIndex: '999999992',
                            boundary: 'window'
                          }">
                          Godkend
                        </button>
                        <button class="do-bttn do-bttn--submit"
                                :class="{'do-bttn--submit--loading': getIsSubmitting(userDay)}"
                                @click="approveDay(userDay)" v-else>Godkend
                        </button>
                      </template>
                    </div>
                  </td>
                </tr>
                </tfoot>
              </template>
            </table>
          </li>
        </ul>
      </template>
    </div>
    <SalarySubsPerfUser v-if="activeUserId"
                        :activeUserId="activeUserId"
                        :startDate="startDate"
                        :endDate="endDate"
                        :usersPackedInDaysWithProps="usersPackedInDaysWithProps"
                        :userDaysSorted="userDaysSorted"
                        :activeFilter="activeFilter"
                        :theUserDaySubmitting="theUserDaySubmitting"
                        :isSalaryIntegrationActive="isSalaryIntegrationActive"
                        :salaryCodes="salaryCodes"
                        :loebenummer="loebenummer"
                        :costCenters="costCenters"
                        :schoolId="schoolId"
                        @updatePropOnLesson="updatePropOnLesson"
                        @setFilter="setFilter($event)"
                        @approveDay="approveDay($event)"
                        @unApproveDay="unApproveDay($event)"
                        @changeStateIsSent="changeStateIsSent($event)"
                        @close="setActiveUserId(null)">
    </SalarySubsPerfUser>
    <SalarySettings
      v-if="isShowSalarySettings"
      :isSalaryIntegrationActive="isSalaryIntegrationActive"
      @update="onUpdate"
      @close="setIsShowSalarySettings(false)">
    </SalarySettings>
  </div>
</template>
<script>
import Datepickerrange from '../datepicker/DatePickerRange.vue'
import moment from 'moment'
import docendo from '../../docendo'
import SalarySettings from './SalarySettings/SalarySettings.vue'
import Loader from '../common/Loader.vue'
import eventbus from '../../eventbus'
import DoDatePickerRange from '../datepicker/DoDatePickerRange.vue'
import SalarySubsPerfUserDay from './SalarySubsPerfUserDay.vue'
import SchoolsSelector from '../common/SchoolsSelector.vue'
import SalarySubsPerfUser from './SalarySubsPerfUser.vue'
import SalaryFilters from './SalaryFilters.vue'
import SalarySubsPerfUserTable from './SalarySubsPerfUserTable.vue'

export default {
  components: {
    SalarySubsPerfUserTable,
    SalaryFilters,
    SalarySubsPerfUser,
    SchoolsSelector,
    SalarySubsPerfUserDay, DoDatePickerRange, Loader, SalarySettings, Datepickerrange
  },
  data () {
    return {
      permission: 'can_manage_salary',
      startDate: moment(this.date).startOf('month').startOf('day'),
      endDate: moment(this.date).endOf('month').endOf('day'),
      isLoading: false,
      usersAndEvents: [],
      isShowSalarySettings: false,
      activeFilter: 'draft',
      theActiveUserDay: null,
      isInitialLoad: true,
      theUserDaySubmitting: null,
      schoolIdsWithSchoolSelector: [7272, 60494],
      selectedSchoolIds: [],
      isSchoolSelectorOn: false,
      activeUserId: null,
      salaryCodes: [{title: 'Timelønnet pædagogmedhjælper', code: 2322}, {title: 'Vikar, ikke uddannet', code: 1212}],
      loebenummer: [0, 1, 2, 3, 4, 5]
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    school () {
      return this.$store.state.activeSchool
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    isSalaryIntegrationActive () {
      return this.school && this.school.features && this.school.features.includes('kmd_opus_integration')
    },
    costCenters () {
      const centers = this.schoolSettings && this.schoolSettings.kmd_opus_cost_centers
      if (!centers) return []

      return Object.entries(centers).map(([title, code]) => ({
        title,  // Label for området (Vest, Øst)
        code   // Koden til cost centeret (54321, 12345)
      }))
    },
    isUserLoaded () {
      return this.$store.state.isUserLoaded
    },
    user () {
      return this.$store.state.user
    },
    userSchools () {
      return this.user && this.user.schools ? this.user.schools : []
    },
    userMemberships () {
      return this.$store.getters.userSchools
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    employmentsInUserIdHash () {
      return this.$store.getters.employmentsInUserIdHash
    },
    dateShortCuts () {
      const custom = [
        {
          title: 'Denne måned',
          startDate: moment(this.date).startOf('month'),
          endDate: moment(this.date).endOf('month')
        },
        {
          title: 'Sidste måned',
          startDate: moment(this.date).subtract(1, 'month').startOf('month'),
          endDate: moment(this.date).subtract(1, 'month').endOf('month')
        }
      ]
      return custom
    },
    dbStartDate () {
      return moment(this.startDate).format('YYYY-MM-DD')
    },
    dbEndDate () {
      return moment(this.endDate).format('YYYY-MM-DD')
    },
    usersAndEventsWithOnlyNewestEvent () {
      let filteredDays = []
      this.usersAndEvents.forEach(userDay => {
        let idx = filteredDays.findIndex(day => day.user_id === userDay.user_id && day.day === userDay.day)
        if (idx < 0) {
          filteredDays.push(userDay)
        } else {
          if (filteredDays[idx].id < userDay.id) {
            filteredDays.splice(idx, 1)
            filteredDays.push(userDay)
          }
        }
      })
      return filteredDays
    },
    userDaysSorted () {
      return this.usersAndEventsWithOnlyNewestEvent.sort((a, b) => {
        return moment(a.day).unix() - moment(b.day).unix()
      })
    },
    userDaysDrafts () {
      return this.userDaysSorted.filter(userDay => userDay.state === 'draft')
    },
    userDaysApproved () {
      return this.userDaysSorted.filter(userDay => userDay.state === 'approved')
    },
    userDaysSent () {
      return this.userDaysSorted.filter(userDay => userDay.state === 'sent')
    },
    usersAndEventsFiltered () {
      if (this.activeFilter === 'draft') {
        return this.userDaysDrafts
      } else if (this.activeFilter === 'approved') {
        return this.userDaysApproved
      } else if (this.activeFilter === 'sent') {
        return this.userDaysSent
      }
    },
    usersPackedInDays () {
      const subs = [] // [{user_id: 21, days: []}]

      this.usersAndEventsFiltered.forEach(userAndDay => {
        const userEmployments = this.getUserEmployments(userAndDay.user_id)

        // Add a formatted date to userDay
        const startEvent = userAndDay.events[0]
        const endEvent = userAndDay.events[userAndDay.events.length - 1]
        const userDayDateFormatted = `${moment(startEvent.start).format('ddd')}, ${moment(startEvent.start).format('LL')}, kl. ${moment(startEvent.start).format('LT')} - ${moment(endEvent.end).format('LT')}`
        userAndDay.v_date_formatted = userDayDateFormatted
        userAndDay.v_unfilled = Object.keys(userAndDay.sums).some(key => key === '')

        const sums = userAndDay.sums

        if (sums && typeof sums === 'object' && Object.keys(sums).length > 0) {
          userAndDay.v_sums = Object.keys(sums).map(key => {
            const employment = userEmployments.find(employment => employment.id === key * 1)
            return {
              employment_not_set: !employment,
              employment_id: key,
              employment_title: employment && employment.title ? employment.title : 'Ikke sat',
              minutes: sums[key],
              minutes_humanized: this.getHumanizeMinutes(sums[key]),
              minutes_to_copy: this.getSumTopCopy(sums[key])
            }
          })
        } else {
          userAndDay.v_sums = [] // or handle the case where sums is not an object or is empty
        }

        const updateUserSums = (currentSumArr, newSumArr) => {
          let arr = currentSumArr
          newSumArr.forEach(item => {
            const idx = arr.findIndex(currentItem => currentItem.employment_id === item.employment_id)
            if (idx < 0) {
              arr.push({...item})
            } else {
              arr[idx]['minutes'] += item.minutes * 1
              arr[idx]['minutes_humanized'] = this.getHumanizeMinutes(arr[idx]['minutes'])
              arr[idx]['minutes_to_copy'] = this.getSumTopCopy(arr[idx]['minutes'])
            }
          })
          return arr
        }
        // Add custom props to each user
        const idx = subs.findIndex(sub => sub.user_id === userAndDay.user_id)
        if (idx < 0) {
          subs.push({
            user_id: userAndDay.user_id,
            days: [userAndDay],
            v_user_name: userAndDay.name,
            v_user_employments: userEmployments,
            v_user_active_employments: userEmployments.filter(employment => !employment.deleted && employment.manual_salary),
            v_user_sums: JSON.parse(JSON.stringify(userAndDay.v_sums))
          })
        } else {
          subs[idx].days.push(userAndDay)
          subs[idx].v_user_sums = updateUserSums(subs[idx].v_user_sums, userAndDay.v_sums)
        }
      })

      return subs
    },
    usersPackedInDaysWithProps () {
      return this.usersPackedInDays.map(user => {
        return {
          ...user,
          days: user.days.map(userAndDay => {
            return {
              ...userAndDay,
              v_is_open: this.getIsTheActiveUserDay(userAndDay)
            }
          })
        }
      })
        .sort((a, b) => a.v_user_name.localeCompare(b.v_user_name))
    },
    localStorageKey () {
      return 'do_salary_subs_schools_' + this.schoolId
    }
  },
  watch: {
    user (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getSavedSchoolIdsAndCheckForPermission()
      }
    }
  },
  methods: {
    parseUserErrors (errors) {
      if (!errors || typeof errors !== 'object') return []

      let errorMessages = []

      Object.keys(errors).forEach(key => {
        let errorList = errors[key]
        if (Array.isArray(errorList)) {
          errorList.forEach(error => {
            let message = `${key}: "${error.Tekst}" (Kode: ${error.Kode}, Type: ${error.Type})`
            errorMessages.push(message)
          })
        }
      })

      return errorMessages
    },
    hideTippy (tippyEl) {
      setTimeout(_ => {
        tippyEl.hide()
      }, 1000)
    },
    copyToClipboard (val, evt) {
      navigator.clipboard.writeText(val.toString()).then(_ => {
        /* clipboard successfully set */
        evt.target._tippy.show()
      }, _ => {
        /* clipboard write failed */
        console.log('that totally failed')
      })
    },
    setActiveUserId (userId) {
      this.activeUserId = userId
      const body = document.querySelector('body')
      if (userId) {
        body.classList.add('no-scroll')
      } else {
        body.classList.remove('no-scroll')
      }
    },
    getHasPermission (schoolId) {
      const schoolMember = this.userMemberships[schoolId]
      if (!schoolMember) {
        return false
      }
      return schoolMember['permissions'].indexOf(this.permission) > -1
    },
    toggleSchool (school) {
      this.usersAndEvents = []
      const idx = this.selectedSchoolIds.indexOf(school.id)
      if (idx < 0) {
        this.selectedSchoolIds.push(school.id)
      } else {
        this.selectedSchoolIds.splice(idx, 1)
      }
      const selectedSchoolIdsWithoutActiveSchoolId = this.selectedSchoolIds.filter(schoolId => schoolId !== this.schoolId)
      if (selectedSchoolIdsWithoutActiveSchoolId.length > 0) {
        this.$helpers.setLocalStorage(this.localStorageKey, JSON.stringify(this.selectedSchoolIds))
      } else {
        this.$helpers.removeLocalStorage(this.localStorageKey)
      }
      if (this.selectedSchoolIds.length > 0) {
        this.readSalary()
      }
    },
    setIsSubmitting (userDay) {
      if (!userDay) {
        this.theUserDaySubmitting = null
      } else {
        this.theUserDaySubmitting = userDay.day_id
      }
    },
    getIsSubmitting (userDay) {
      return this.theUserDaySubmitting === userDay.day_id
    },
    updatePropOnLesson (obj) {
      const idx = this.usersAndEvents.findIndex(userDay => userDay.day_id === obj.userDay.day_id)
      // If userDay not found, exit
      if (idx < 0) {
        return
      }
      const eventIdx = this.usersAndEvents[idx]['events'].findIndex(event => event.event_id === obj.event.event_id)
      // If event not found, exit
      if (eventIdx < 0) {
        return
      }
      this.usersAndEvents[idx]['events'][eventIdx][obj.propToUpdate] = obj.val * 1
      if (this.isSalaryIntegrationActive && obj.propToUpdate === 'employment_id') {
        const userEmployment = obj.user.v_user_employments.find(
          employment => employment.id === Number(obj.val)
        )
        if (userEmployment) {
          if (userEmployment.default_loebenummer) {
            this.usersAndEvents[idx].events[eventIdx].loebenummer = Number(userEmployment.default_loebenummer)
          }
          if (userEmployment.default_loenart) {
            this.usersAndEvents[idx].events[eventIdx].loenart = Number(userEmployment.default_loenart)
          }
        }
      }
      this.saveDay(this.usersAndEvents[idx])
    },
    saveDay (userDay) {
      docendo.salaryDayUpdate(this.schoolId, this.selectedSchoolIds, userDay, success => {
        this.setIsSubmitting(null)
        const days = success && success.days ? success.days : []
        days.forEach(userDaySuccess => {
          const idx = this.usersAndEvents.findIndex(userDay => userDay.day_id === userDaySuccess.day_id)
          if (idx > -1) {
            this.$set(this.usersAndEvents, idx, userDaySuccess)
          }
        })
      })
    },
    changeStateIsSent (userDay) {
      this.setIsSubmitting(userDay)
      let updatedUserDay = JSON.parse(JSON.stringify(userDay))
      updatedUserDay['state'] = 'sent'
      this.saveDay(updatedUserDay)
    },
    unApproveDay (userDay) {
      this.setIsSubmitting(userDay)
      let updatedUserDay = JSON.parse(JSON.stringify(userDay))
      updatedUserDay['state'] = 'draft'
      this.saveDay(updatedUserDay)
    },
    approveDay (userDay) {
      this.setIsSubmitting(userDay)
      let updatedUserDay = JSON.parse(JSON.stringify(userDay))
      updatedUserDay['state'] = 'approved'
      this.saveDay(updatedUserDay)
    },
    getHumanizeMinutes (data) {
      let totalMinutes = data
      let hours = Math.floor(totalMinutes / 60)
      let minutes = totalMinutes % 60
      let hoursTitle = hours === 1 ? 'time' : 'timer'
      return '(' + hours + ' ' + hoursTitle + ' ' + minutes + ' ' + 'min)' + ' - ' + (totalMinutes / 60).toFixed(2) + ' timer'
    },
    getSumTopCopy (totalMinutes) {
      return (totalMinutes / 60).toFixed(2)
    },
    getIsDayValidated (userAndDay) {
      return !userAndDay.events.every(event => event.employment_id)
    },
    getUserEmployments (userId) {
      return this.employmentsInUserIdHash[userId] ? this.employmentsInUserIdHash[userId] : []
    },
    getIsTheActiveUserDay (userDay) {
      return this.theActiveUserDay === userDay.day_id
    },
    setTheActiveUserDay (userDay) {
      this.theActiveUserDay = (this.theActiveUserDay === userDay.day_id) ? null : userDay.day_id
    },
    setFilter (filter) {
      this.activeFilter = filter
    },
    setIsShowSalarySettings (bool) {
      this.isShowSalarySettings = bool
    },
    startDateChanged (date) {
      this.startDate = date
      if (!this.isInitialLoad) {
        this.readSalary()
      }
    },
    endDateChanged (date) {
      this.endDate = date
      if (!this.isInitialLoad) {
        this.readSalary()
      }
    },
    onUpdate () {
      this.readSalary()
    },
    readSalary () {
      if (this.selectedSchoolIds.length < 1) {
        this.usersAndEvents = []
        return
      }
      this.isLoading = true
      docendo.salaryDays(this.schoolId, this.selectedSchoolIds, this.dbStartDate, this.dbEndDate, success => {
        if (success.status === 'error') {
          eventbus.toast = {text: success.message, success: false}
          this.isLoading = false
          return
        }
        this.usersAndEvents = success.days
        this.isLoading = false
        if (this.isInitialLoad) {
          this.isInitialLoad = false
        }
      }, failure => {
        eventbus.toast = {text: failure, success: false}
        this.isLoading = false
      })
    },
    getSavedSchoolIdsAndCheckForPermission () {
      if (!this.isUserLoaded) {
        return
      }

      // Retrieve saved school IDs from localStorage
      const localStorageSelectedSchoolIds = this.$helpers.getLocalStorage(this.localStorageKey)
      let selectedSchoolIds = []
      if (localStorageSelectedSchoolIds) {
        try {
          const parsedSchoolIds = JSON.parse(localStorageSelectedSchoolIds)
          parsedSchoolIds.forEach(schoolId => {
            if (this.getHasPermission(schoolId) && !selectedSchoolIds.includes(schoolId)) {
              selectedSchoolIds.push(schoolId)
            }
          })
          const selectedSchoolIdsWithoutActiveSchoolId = selectedSchoolIds.filter(schoolId => schoolId !== this.schoolId)

          // If there are valid school IDs left, update localStorage, otherwise remove it
          // We change it to remove any schools selected that user isn't on any more
          if (selectedSchoolIdsWithoutActiveSchoolId.length > 0) {
            this.$helpers.setLocalStorage(this.localStorageKey, JSON.stringify(selectedSchoolIds))
          } else {
            this.$helpers.removeLocalStorage(this.localStorageKey)
          }

          // Update selectedSchoolIds in the component
          if (selectedSchoolIdsWithoutActiveSchoolId.length === 0) {
            this.selectedSchoolIds = [this.schoolId]
          } else {
            this.selectedSchoolIds = selectedSchoolIds
          }

          // Call readSalary after updating selectedSchoolIds
          this.readSalary()
        } catch (e) {
          console.error('Error parsing localStorage data', e)
        }
      }
    }
  },
  mounted () {
    // this.$store.dispatch('readEmploymentTypes')
    this.$store.dispatch('readEmployments')
    if (this.schoolIdsWithSchoolSelector.includes(this.schoolId)) {
      this.isSchoolSelectorOn = true
    } else {
      this.$helpers.removeLocalStorage(this.localStorageKey)
    }
    // READ SALARY FOR SELECTED SCHOOLS
    const localStorageSelectedSchoolIds = this.$helpers.getLocalStorage(this.localStorageKey)
    // If nothing saved then just call with active school
    if (!localStorageSelectedSchoolIds) {
      this.selectedSchoolIds = [this.schoolId]
      this.readSalary()
    } else {
      this.getSavedSchoolIdsAndCheckForPermission()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.sub-salary {
  min-height: 50vh;
}

.sub-salary__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sub-salary__header__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-list {
  margin: 1rem 0;
}

.user-list__user {
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
  background: #fff;
  border: 1px solid #d8d8d8;
  margin: 0 0 2rem 0;
}

.user-list__user__header {
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-list__user__header h4 {
  font-size: 16px;
  font-weight: bold;
}

.user-list__user__header__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-list__user__header ul {
  border-right: 1px solid #ccc;
  padding-right: 1rem;
  text-align: right;
  margin: 0;
}

.user-list__user__table {
  width: 100%;
  border-collapse: collapse;
}

.user-list__user__table.user-list__user__table--active {
  box-shadow: 0px 0px 0 1px #cdcdcd;
  margin-bottom: 1px;
}

.user-list__user__table thead tr {
  cursor: pointer;
  background: #f6f9fc;
  border-top: 1px solid #e2e8f0;
  transition: 0.15s;
}

.user-list__user__table thead tr:hover {
  background: #ebeff4
}

.user-list__user__table thead tr th {
  color: #6b7280;
  text-transform: uppercase;
  font-size: .85rem;
}

.user-list__user__table thead tr th,
.user-list__user__table tbody tr td {
  padding: 0.5rem;
}

.user-list__user__table tbody {
  border-top: 1px solid #e2e8f0;
}

.user-list__user__table tfoot {
  background-color: #f3f4f6;
}

.user-list__user__footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 1rem;
}

.user-list__user > table:last-child thead tr {
  border-radius: 0 0 4px 4px;
}

.user-list__user > table:last-child thead tr th:first-child {
  border-radius: 0 0 0 4px;
}

.user-list__user > table:last-child thead tr th:last-child {
  border-radius: 0 0 4px 0;
}

.user-list__user__table__arrow {
  padding-right: 0.75rem;
  text-align: right;
  position: relative;
}

.user-list__user__table__arrow svg {
  position: absolute;
  right: 60px;
  top: 8px;
}

.user-list__user__table__arrow > span {
  margin-right: 1.13rem;
}

.user-list__user__footer__sums {
  text-align: right;
  margin: 1rem 0;
}

.user-list__user__footer__sums__sum--not-set {
  color: var(--danger);
}

.submit-buttons {
  gap: 1rem;
}

.do-copy-bttn {
  height: 24px;
  width: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.do-copy-bttn > svg {
  height: 14px;
  width: 14px;
  pointer-events: none;
}

.do-bttn.do-bttn--small {
  font-size: 11px;
  height: auto;
  padding: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.do-pill.do-pill--with-icon {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 11px;
  text-transform: none;
}

.do-bttn--with-link {
  position: relative;
}

.do-bttn > a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #222;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// SalarySubsPerf.vue?6759f600